export enum RouterPathEnum {
  FirstPage = "/",
  Main = "characterChoice",
  Scene = "scene",
  Dashboard = "dashboard",
  Auth = "/auth",
  DoctorPage = "doctor",
  Profile = "/profile",
  CreateCharacterPage = "create-character",
  RegistrationPage = "/register",
  SceneMuscle = "scenemuscle",
  SceneMap = "scenemap",
  KeyLost = "/keylost",
  Explanation = "/explanation",
  KBGU = "kbgu",
  Metabolism = "metabolism",
  Routing = "/routing",
}

export enum DragNDropEvents {
  DragEnter = "dragenter",
  DragLeave = "dragleave",
  DragOver = "dragover",
  Drop = "drop",
}
